import { render, staticRenderFns } from "./background.vue?vue&type=template&id=0de7048a&scoped=true&"
import script from "./background.vue?vue&type=script&lang=js&"
export * from "./background.vue?vue&type=script&lang=js&"
import style0 from "./background.vue?vue&type=style&index=0&id=0de7048a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0de7048a",
  null
  
)

export default component.exports